import getNameReduxUtil from 'modules/redux/utils/get-name/index.js'

export default function isPowerHybridChallengeWorkoutUtil (workout) {
  return /powerhybrid/gi.test(getNameReduxUtil(workout))
}
